import { jsx, jsxs } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel, useClickOut } from '@websolutespa/bom-mixer-hooks';
import { AnimatePresence, motion } from 'framer-motion';
import { useRef } from 'react';
import { useActions } from '../../../useLlm/useActions.js';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';
import style from './page-prompt.module.scss.js';

const PagePrompt = () => {
  useLabel();
  const {
    PageActions,
    PageContext,
    PageDictate,
    PageMenu,
    PageStop,
    PageStreamingIndicator,
    PageSubmit,
    PageSynthesis,
    PageTextarea,
    PageTrigger,
    PageUpload
  } = useLlm(state => state.components);
  const ref = useRef(null);
  const streaming = useLlm(state => state.streaming);
  const opened = useLlmView(state => state.opened);
  const {
    open
  } = useLlmView(state => state.actions);
  const idle = useLlmView(state => {
    const {
      idle,
      opened
    } = state;
    // const shouldShowTrigger = (!opened && !idle && !embed && !imperative) || Boolean(app?.contents.customIntro && !introed);
    return idle && !opened;
  });
  const {
    wrapper
  } = useActions();
  useClickOut(ref, event => {
    var _a;
    const className = ((_a = event.target) === null || _a === void 0 ? void 0 : _a.getAttribute('class')) || '';
    // console.log('useClickOut', className);
    if (className.indexOf('llm') === -1 && opened) {
      open();
    }
  });
  // console.log('idle', idle);
  return jsx(AnimatePresence, {
    children: !idle && jsxs(motion.section, {
      ref: ref,
      className: getClassNames(style.prompt, {
        [style.open]: opened
      }),
      initial: {
        y: '200%',
        opacity: 0
      },
      animate: {
        y: 0,
        opacity: 1
      },
      exit: {
        y: '200%',
        opacity: 0
      },
      transition: {
        duration: .4
      },
      "aria-label": "Prompt",
      children: [jsx(PageTrigger, {}), wrapper ? jsx(PageActions, {
        wrapper: wrapper
      }) : jsxs("form", {
        className: getClassNames(style.form, '-form'),
        onSubmit: event => event.preventDefault(),
        children: [jsx(PageMenu, {}), jsxs("div", {
          className: getClassNames(style.control, {
            [style.streaming]: streaming
          }),
          children: [jsx(PageStreamingIndicator, {}), jsx(PageTextarea, {}), jsx(PageUpload, {}), jsx(PageContext, {}), jsx(PageDictate, {}), jsx(PageSynthesis, {})]
        }), streaming ? jsx(PageStop, {}) : jsx(PageSubmit, {})]
      })]
    })
  });
};

export { PagePrompt };
//# sourceMappingURL=page-prompt.js.map
